import React from "react";

export const PlanDateContext = React.createContext(null);

export const withPlanDate = (Component) => (props) => {
  return (
    <PlanDateContext.Consumer>
      {(dateRange) => (
        <Component
          {...props}
          planDate={dateRange?.planDate}
          startDate={dateRange?.startDate}
        />
      )}
    </PlanDateContext.Consumer>
  );
};
